export default function buildPromotionClickEvent(promotionData, eventCallback) {
  const { gtmPageType, collectionFopIdx, section, offer } = promotionData;
  const event = {
    event: offer.id2 ? 'promotionClick' : 'productPromotionClick', // graphic promotions have id2, product promotions - don't
    pageTypeDimension: gtmPageType,
    ecommerce: {
      promoClick: {
        promotions: [{
          id: offer.id,
          id2: offer.id2,
          name: offer.text,
          creative: offer.creative || '',
          position: collectionFopIdx,
        }],
      },
    },
    uaEventCategory: 'E-Commerce',
    uaEventAction: 'promotionClick',
    uaEventLabel: `${gtmPageType}${section.title ? `|${section.title}` : ''}`, // TODO it is implemented same way as in webshop, but it is inconsistent with buildPromotionImpressionsEvents.js and other events
    uaEventValue: 1,
  };

  if (eventCallback) {
    event.eventCallback = eventCallback;
    event.eventTimeout = 2000;
  }

  return event;
}
